const _require = require('lodash'),
  isPlainObject = _require.isPlainObject;
const _require2 = require('../../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const _require3 = require('../../lib/irtc/assignmentGroups'),
  processAssignments = _require3.processAssignments;

/**
  * @function evalute - evaluate itiAssignmentCountsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const checklists = await evaluateSource(source.checklists, content, parentContentPath, transientContext, nativeFunctions);
  if (checklists === undefined || !isPlainObject(checklists)) {
    return undefined;
  }
  const result = {
    open: 0,
    complete: 0,
    unassigned: 0
  };
  processAssignments(checklists, (identifier, plusOpen, plusComplete) => {
    if (identifier === undefined) {
      result.unassigned += 1;
    } else {
      result.open += plusOpen;
      result.complete += plusComplete;
    }
  });
  return result;
};
module.exports = {
  evaluate
};